kv.controller('landlordViewCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal,cmdate, $rootScope, $injector) {
	var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
	vm.primaryKey = 'tenant_id';
	vm.entity = 'tenant';
	vm.entityType = 'tenant';
	vm.groups = {};

	let url_segments = window.location.pathname.split('/');
	let page_entity_id = url_segments[2];
	let page_identifier = url_segments[3];

	vm.entityId = page_entity_id;
	vm.commentsConfig = {
		entity_type: vm.entity
	};




    /**
     * Impersonate user
     *
     * @param userId
     * @param userName
     */
    vm.impersonateUser = function(userId, userName) {
        vm.confirm('Are you sure you want to impersonate user "' + userName + '"?')
            .then(response => {
                if (response !== 'ok')
                    return;

                KApp.block('.k_content_body');

                // Use AJAX instead of direct navigation
                $http({
                    method: 'POST',
                    url: '/landlord/' + vm.entityId + '/impersonate/' + userId,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                })
                    .then(function(response) {
                        console.log('Success response:', response);
                        // Check if the response indicates success
                        if (response && response.data && response.data.status === true) {
                            toastr.success(response.data.message || 'Impersonation successful', { timeOut: 2000 });
                            // Redirect after showing success message
                            setTimeout(function() {
                                window.location.href = response.data.redirect || '/';
                            }, 500);
                        } else if (response && response.data) {
                            toastr.error(response.data.message || 'Impersonation failed');
                        } else {
                            toastr.error('Unexpected response format');
                        }
                    })
                    .catch(function(error) {
                        console.log('Error response:', error);
                        // Handle actual HTTP errors (403, 500, etc.)
                        if (error && error.data && error.data.message) {
                            toastr.error(error.data.message);
                        } else if (error && error.data && error.data.status === false) {
                            toastr.error(error.data.message || 'Impersonation failed');
                        } else if (error && error.statusText) {
                            toastr.error(error.statusText);
                        } else {
                            toastr.error('An error occurred during impersonation');
                        }
                    })
                    .finally(function() {
                        KApp.unblock('.k_content_body');
                    });
            });
    };

    /**
     * Show 2FA modal for impersonation
     */
    // vm.show2FAModal = function(userId, userName) {
    //     var modalInstance = $uibModal.open({
    //         templateUrl: '/views/common/modals/two-factor-code.html',
    //         controller: 'TwoFactorCodeModalCtrl',
    //         controllerAs: 'modal',
    //         size: 'md',
    //         resolve: {
    //             userName: function() {
    //                 return userName;
    //             }
    //         }
    //     });
    //
    //     modalInstance.result.then(function(twoFactorCode) {
    //         vm.proceedWithImpersonation(userId, userName, twoFactorCode);
    //     });
    // };
    //
    // /**
    //  * Proceed with impersonation after 2FA verification
    //  */
    // vm.proceedWithImpersonation = function(userId, userName, twoFactorCode) {
    //     vm.confirm('Are you sure you want to impersonate user "' + userName + '"?')
    //         .then(response => {
    //             if (response !== 'ok')
    //                 return;
    //
    //             KApp.block('.k_content_body');
    //
    //             // Build URL with 2FA code if provided
    //             var url = '/landlord/' + vm.entityId + '/impersonate/' + userId;
    //
    //             if (twoFactorCode) {
    //                 // Send as POST with 2FA code
    //                 $http.post(url, { two_factor_code: twoFactorCode })
    //                     .then(function(response) {
    //                         window.location.href = '/';
    //                     })
    //                     .catch(function(error) {
    //                         KApp.unblock('.k_content_body');
    //                         const msg = (error.data && error.data.message) || 'Invalid 2FA code or impersonation failed';
    //                         toastr.error(msg);
    //                     });
    //             } else {
    //                 // Original behavior without 2FA
    //                 window.location.href = url;
    //             }
    //         });
    // };

    /**
     * Change tenant status
     * @param status
     */
    vm.changeTenantStatus = function(status) {
        let tenantId = vm.entityId;
        let message = status === 'enable'
            ? 'Enable this tenant?'
            : 'Disable this tenant?';
        let actionUrl = status === 'enable'
            ? '/landlord/' + tenantId + '/actions/enable'
            : '/landlord/' + tenantId + '/actions/disable';

        vm.confirm(message)
            .then(response => {
                if (response !== 'ok')
                    return;
                KApp.block('.k_content_body');

                $http.post(actionUrl)
                    .then(function(response) {
                        console.log('HTTP', response.status, 'body:', response.data);

                        // If backend returns structured JSON:
                        if (response.data && typeof response.data === 'object') {
                            if (response.data.status === true) {
                                toastr.success(response.data.message || 'Status changed', { timeOut: 2000 });
                                window.location.reload();
                            } else {
                                toastr.error(response.data.message || 'Error changing status');
                            }
                            return;
                        }

                        // Fallback when no body is returned (204) or non-JSON
                        if (response.status === 204 || !response.data) {
                            toastr.success('Status changed (no response body)', { timeOut: 2000 });
                            window.location.reload();
                            return;
                        }

                        // Generic fallback
                        toastr.success('Status change completed', { timeOut: 2000 });
                    })
                    .catch(function(error) {
                        // Angular $http error may include error.data or error.statusText
                        const msg = (error.data && error.data.message) || error.statusText || 'An error occurred';
                        toastr.error('An error occurred: ' + msg);
                    })
                    .finally(function() {
                        KApp.unblock('.k_content_body');
                    });

        });
    };

	return vm;
});
